import * as React from 'react';
import { TextInput } from '@workday/canvas-kit-react/text-input';
import { createComponent } from '@workday/canvas-kit-react/common';
import { GoToContext } from './useGoToForm';
export const GoToTextInput = createComponent('input')({
    displayName: 'Pagination.GoToTextInput',
    Component(elemProps, ref, Element) {
        const { inputProps } = React.useContext(GoToContext);
        return React.createElement(TextInput, Object.assign({ ref: ref, as: Element, size: 1, width: 55 }, inputProps, elemProps));
    },
});
